const AdminRoutes = ['/admin','/admin/facturacion','/admin/usuarios'];
export default AdminRoutes;